var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dashboard", attrs: { id: "dashboard" } }, [
    _c("div", { staticClass: "row dashboard__row" }, [
      _c("div", { staticClass: "col-md-12" }, [_c("NewsBannersCard")], 1)
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row dashboard__row" },
      _vm._l(_vm.fullWidthCards, function(permission) {
        return _c(
          "div",
          { staticClass: "col-md-12" },
          [_c(_vm.cardName(permission.perm_desc), { tag: "component" })],
          1
        )
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { staticClass: "row dashboard__row" }, [
      _c("div", { staticClass: "col-md-12" }, [_c("AccountsCard")], 1)
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row dashboard__row" }, [
      _c("div", { staticClass: "col-md-12" }, [_c("ContactsCard")], 1)
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row dashboard__row" },
      [
        _vm._l(_vm.halfWidthCards, function(permission) {
          return _c(
            "div",
            { staticClass: "col-6 col-md-6" },
            [_c(_vm.cardName(permission.perm_desc), { tag: "component" })],
            1
          )
        }),
        _vm._v(" "),
        _c("div", { staticClass: "col-6 col-md-6" }, [_c("ConnectionsCard")], 1)
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }